import { QueryConfig } from "@/api/types/query.types";
import { useApiQuery, UseApiQueryOptions } from "./useApiQuery";
import { PrimitiveAtom, useSetAtom } from "jotai";
import { QueryAtom } from "../../types/query.types";
import { useLayoutEffect, useMemo } from "react";

export function useApiQueryWithAtom<R, P = any>(
    query: QueryConfig<R, P>,
    atom: PrimitiveAtom<QueryAtom<R>>,
    hookOptions?: UseApiQueryOptions<R, P>,
) {
    const result = useApiQuery(query, hookOptions);
    const setAtom = useSetAtom(atom);

    const atomValue = useMemo(
        (): QueryAtom<R> => ({
            isLoading: !!result.isLoading,
            isError: !!result.isError,
            data: result.data ?? null,
        }),
        [result.isLoading, result.isError, result.data, result.dataUpdatedAt],
    );

    useLayoutEffect(() => {
        console.log("useApiQueryWithAtom setting atom:", {
            isLoading: atomValue.isLoading,
            dataLength: Array.isArray(atomValue.data)
                ? atomValue.data.length
                : atomValue.data,
            dataUpdatedAt: result.dataUpdatedAt,
        });
        setAtom(atomValue);
    }, [atomValue, setAtom]);

    return result;
}
